/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityRef } from './entityRef';

export interface OrgContextVersionOut {
  version: number;
  created_by: EntityRef | null;
  created_at: string;
  markdown?: string | null;
}
